// Split a notification `link` string into a pathname + parsed search object so
// TanStack Router navigates with proper search params. The router builds/reads
// search from the `search` option, not from an inline `?foo=bar` in `to`, so a
// link like `/schedule/<tripId>?legId=<legId>` must be split before navigating.
export function parseNotificationLink(link: string): {
  to: string
  search?: Record<string, string>
} {
  const [to, query] = link.split('?')
  if (!query) return { to }
  return { to, search: Object.fromEntries(new URLSearchParams(query)) }
}
